/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComunicazioneEmailEsitoDTO { 
    /**
     * Assente se l\'account e\' stato anonimizzato dopo l\'invio.
     */
    user_id?: string;
    nome?: string;
    cognome?: string;
    esito?: ComunicazioneEmailEsitoDTOEsitoEnum;
    /**
     * INDIRIZZO_NON_VALIDO, SMTP_RIFIUTATO, SMTP_NON_RAGGIUNGIBILE o ERRORE_INVIO; presente solo per gli esiti FALLITA.
     */
    errore_codice?: string;
}
export enum ComunicazioneEmailEsitoDTOEsitoEnum {
    IN_ATTESA = 'IN_ATTESA',
    INVIATA = 'INVIATA',
    FALLITA = 'FALLITA',
    SALTATA_SENZA_EMAIL = 'SALTATA_SENZA_EMAIL',
    ESITO_IGNOTO = 'ESITO_IGNOTO'
};



